var React = require('react');

function DownLeft (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"icons / diagonal arrow / 24px / down left"),React.createElement("g",{"id":"icons-/-diagonal-arrow-/-24px-/-down-left","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","key":1},React.createElement("path",{"d":"M24,7.63833441e-14 L24,16 L22,16 L21.999,3.419 L1.41421356,24.0045238 L-1.139977e-12,22.5903102 L20.59,2 L8,2 L8,7.63833441e-14 L24,7.63833441e-14 Z","id":"down-left","fill":"currentColor","transform":"translate(12.000000, 12.002262) scale(-1, -1) translate(-12.000000, -12.002262) "}))]);
}

DownLeft.defaultProps = {"width":"24px","height":"24px","viewBox":"0 0 24 24","version":"1.1"};

module.exports = DownLeft;

DownLeft.default = DownLeft;
